import { useNavigate } from '@tanstack/react-router'
import { Row, Stack } from '@/components/ui'

export default function SiteFooter() {
  const navigate = useNavigate()
  const go = (to: string) => navigate({ to })

  const col = (title: string, links: Array<[string, string]>) => (
    <Stack gap="md">
      <div
        style={{
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: '0.16em',
          textTransform: 'uppercase',
          color: 'var(--gold-400)',
        }}
      >
        {title}
      </div>
      {links.map(([lbl, to]) => (
        <a
          key={lbl}
          href={to}
          onClick={(e) => {
            e.preventDefault()
            go(to)
          }}
          style={{
            color: 'var(--emerald-100)',
            fontSize: 15,
            textDecoration: 'none',
            opacity: 0.92,
          }}
        >
          {lbl}
        </a>
      ))}
    </Stack>
  )

  return (
    <footer
      style={{
        position: 'relative',
        background: 'var(--surface-emerald-deep)',
        color: 'var(--text-on-emerald)',
        overflow: 'hidden',
        marginTop: 'auto',
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: "url('/assets/zellij-tile.svg')",
          backgroundSize: '120px 120px',
          opacity: 0.08,
        }}
      />
      <div
        style={{
          position: 'relative',
          maxWidth: 'var(--container-max)',
          margin: '0 auto',
          padding: 'var(--space-16) var(--gutter) var(--space-10)',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1.6fr 1fr 1fr 1fr',
            gap: 40,
          }}
          className="oumma-contact-grid"
        >
          <div>
            <Row gap="sm" style={{ marginBottom: 14 }}>
              <img
                src="/assets/oumma-mark-gold.svg"
                alt=""
                width="34"
                height="34"
              />
              <span
                style={{
                  fontFamily: 'var(--font-display)',
                  fontWeight: 700,
                  fontSize: 26,
                  color: 'var(--paper-0)',
                }}
              >
                Oumma
              </span>
            </Row>
            <p
              style={{
                color: 'var(--emerald-100)',
                fontSize: 15.5,
                lineHeight: 1.6,
                maxWidth: 320,
                opacity: 0.9,
              }}
            >
              Oumma est une plateforme dédiée à la communauté musulmane pour
              faciliter le partage et la découverte d'événements communautaires.
            </p>
          </div>
          {col('Découvrir', [
            ['Événements', '/events'],
            ['Communautés', '/communautes'],
            ['Proposer un événement', '/new-event'],
          ])}
          {col('Participer', [
            ['Mes événements', '/my-events'],
            ['Mon profil', '/me'],
          ])}
          {col('Oumma', [
            ['Contact', '/contact'],
            ['Se connecter', '/login'],
          ])}
        </div>
        <div
          className="oumma-rule"
          style={{ margin: 'var(--space-12) 0 var(--space-6)', opacity: 0.5 }}
        >
          <img
            src="/assets/oumma-mark-gold.svg"
            alt=""
            width="18"
            height="18"
          />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 10,
            color: 'var(--emerald-100)',
            fontSize: 13.5,
            opacity: 0.8,
          }}
        >
          <span>© 2026 Oumma · Fait avec soin pour la communauté</span>
          <span style={{ fontFamily: 'var(--font-mono)' }}>
            Assalamu alaikum — bienvenue
          </span>
        </div>
      </div>
    </footer>
  )
}
